export default {"src":"/_next/static/media/Quote.d78db1a8.svg","height":33,"width":44,"blurWidth":0,"blurHeight":0};